export const weekDays = [
  { id: 1, name: "MONDAY", nick_name: "Mon." },
  { id: 2, name: "TUESDAY", nick_name: "Tue." },
  { id: 3, name: "WEDNESDAY", nick_name: "Wed." },
  { id: 4, name: "THURSDAY", nick_name: "Thur." },
  { id: 5, name: "FRIDAY", nick_name: "Fri." },
  { id: 6, name: "SATURDAY", nick_name: "Sat." },
  { id: 7, name: "SUNDAY", nick_name: "Sun." },
];
